import { Text } from "@/components";
import { FaCheck } from "react-icons/fa6";

export const FastResp = () => {
  return (
    <div className="container mx-auto">
      <div className="mx-auto flex flex-col items-center">
        <Text.Heading className="text-white lg:px-[100px] text-center">
          <span>
            Concierge equity management service with&nbsp;
            <span className="text-secondary">24 hour response</span>
          </span>
        </Text.Heading>

        <div className="text-center text-lg mt-4 md:mt-6">
          Let us to take care of all your equity management needs.
        </div>

        <div className="w-full mx-auto grid md:grid-cols-2 gap-4 md:gap-8 mt-6 md:mt-10 2xl:max-w-screen-xl">
          {[
            "Did you just bring on a new advisor? Shoot us the signed agreement and we’ll upload it to your cap table.",
            "Are you talking to an investor about terms for a future round? Just let us know and we’ll run a dilution simulation for you.",
            "Have an upcoming investor meeting and want to show them how much they’ll make if you exit at a $1.5b valuation?",
            "Whatever it is.... we got you. (And won’t charge you $300/hr and take a week to get back to you.)",
          ].map((text, tIdx) => (
            <div className="flex gap-4" key={tIdx}>
              <div className="min-w-5 min-h-5 max-w-5 max-h-5 flex items-center justify-center rounded-full bg-secondary mt-1.5">
                <FaCheck color="var(--background)" size={12} />
              </div>

              <div className="text-lg">{text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
